import { useMemo } from 'react';

import { useSelector } from 'store/utils/redux/hooks';
import * as noteStore from 'store/nodes/note';

const useCopilotConfig = (id: number | 'create') => {
  const variant = useSelector(noteStore.selectors.selectedContext(id));

  const resourceId = useMemo(() => {
    return id === 'create' || variant === 'library-fulltext' ? 0 : id;
  }, [variant, id]);

  return {
    variant,
    resourceId,
  };
};

export default useCopilotConfig;
